import { DataBean } from "../DataBean";


export class AdquisitionContractModify extends DataBean {

    public async getAdquisitionContractModifyCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getAdquisitionContractModifyCatalogPorPropiedadesLike_java.util.Map_Number", [properties, maxRows]);
    }
    public async getAdquisitionContractModifyRender(idAdquisitionContract: number): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getAdquisitionContractModifyRender_Number", [idAdquisitionContract]);
    }

    public async updateAdquisitionContractModify(bean: any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.orange.bean.AdquisitionContractModify_updateAdquisitionContractModify_com.orange.bean.AdquisitionContractModify", [{
            "DataBeanProperties": bean,
            "DataBeanName": "com.orange.bean.AdquisitionContractModify"
        }]);
    }
}